import { siteConfig } from "@/mocks/siteData";
import PageMeta from "@/components/feature/PageMeta";
import HeroSection from "./components/HeroSection";
import CategoryNav from "./components/CategoryNav";
import FeaturedVideos from "./components/FeaturedVideos";
import LatestContent from "./components/LatestContent";
import TrendingSection from "./components/TrendingSection";
import FAQSection from "./components/FAQSection";

export default function Home() {
  const homeSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: siteConfig.siteName,
    url: siteConfig.siteUrl,
    description: siteConfig.siteDescription,
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: `${siteConfig.siteUrl}/search?q={search_term_string}`,
      },
      "query-input": "required name=search_term_string",
    },
  };

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: siteConfig.siteName,
    url: siteConfig.siteUrl,
    description: siteConfig.siteDescription,
    email: siteConfig.contactEmail,
    telephone: siteConfig.contactPhone,
    address: {
      "@type": "PostalAddress",
      streetAddress: "建国路88号爱情岛大厦",
      addressLocality: "北京",
      addressRegion: "北京",
      addressCountry: "CN",
    },
  };

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "爱情岛论坛是什么？",
        acceptedAnswer: { "@type": "Answer", text: "爱情岛论坛是一个专注于情感交流与视频内容的综合社区平台。我们提供高清视频在线观看服务，涵盖恋爱技巧、情感故事、婚姻经营、心理学堂等多个板块。" },
      },
      {
        "@type": "Question",
        name: "爱情岛论坛的视频需要下载吗？",
        acceptedAnswer: { "@type": "Answer", text: "完全不需要！爱情岛论坛的所有视频均支持在线高清播放。只需打开网页即可流畅观看，无需下载任何播放器或视频文件。" },
      },
      {
        "@type": "Question",
        name: "爱情岛论坛支持哪些设备观看？",
        acceptedAnswer: { "@type": "Answer", text: "爱情岛论坛完美适配电脑、平板和手机等各种设备。无论使用Windows、Mac、iOS还是Android系统，都可以通过浏览器直接访问。" },
      },
      {
        "@type": "Question",
        name: "爱情岛论坛的视频内容是免费的吗？",
        acceptedAnswer: { "@type": "Answer", text: "是的，爱情岛论坛的所有视频内容均免费向用户开放。我们致力于打造开放、共享的情感知识平台。" },
      },
    ],
  };

  return (
    <>
      <PageMeta
        title={`${siteConfig.siteName}在线观看 - 免费高清视频入口`}
        description={siteConfig.siteDescription}
        keywords={siteConfig.siteKeywords}
        canonicalUrl={siteConfig.siteUrl}
        ogTitle={`${siteConfig.siteName}在线观看 - 免费高清视频入口`}
        ogDescription={siteConfig.siteDescription}
        ogType="website"
        ogUrl={siteConfig.siteUrl}
        jsonLd={[homeSchema, orgSchema, faqSchema]}
      />

      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedVideos />
        <LatestContent />
        <TrendingSection />
        <FAQSection />
      </main>
    </>
  );
}